"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointIn = void 0;
class EndpointIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointIn.attributeTypeMap;
    }
}
exports.EndpointIn = EndpointIn;
EndpointIn.discriminator = undefined;
EndpointIn.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "disabled",
        "baseName": "disabled",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "filterTypes",
        "baseName": "filterTypes",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "metadata",
        "baseName": "metadata",
        "type": "{ [key: string]: string; }",
        "format": ""
    },
    {
        "name": "rateLimit",
        "baseName": "rateLimit",
        "type": "number",
        "format": "uint16"
    },
    {
        "name": "secret",
        "baseName": "secret",
        "type": "string",
        "format": ""
    },
    {
        "name": "uid",
        "baseName": "uid",
        "type": "string",
        "format": ""
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "version",
        "baseName": "version",
        "type": "number",
        "format": "uint16"
    }
];
//# sourceMappingURL=EndpointIn.js.map